import { InfoCircleOutlined } from '@ant-design/icons';
import { Modal, Space } from 'antd';
import cx from 'classnames';
import React from 'react';
var FeedbackTicketModal = function FeedbackTicketModal(props) {
  var visible = props.visible,
    onCancel = props.onCancel,
    url = props.url,
    ticketModalTitle = props.ticketModalTitle,
    ticketModalWrapperClassName = props.ticketModalWrapperClassName;
  var renderTitle = function renderTitle() {
    return ticketModalTitle || /*#__PURE__*/React.createElement("div", {
      className: "dr-feedback-modal-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dr-feedback-modal-header-title"
    }, "\u63D0\u4EA4\u9875\u9762\u53CD\u9988"), /*#__PURE__*/React.createElement(Space, {
      className: "dr-feedback-modal-tips"
    }, /*#__PURE__*/React.createElement(InfoCircleOutlined, {
      style: {
        color: '#FFA940'
      },
      rev: undefined
    }), /*#__PURE__*/React.createElement("div", null, "\u4EC5\u9002\u7528\u4E8E\u5F53\u524D\u7F51\u9875\u7684\u610F\u89C1\u6536\u96C6\uFF0C\u5E06\u8F6F\u4EA7\u54C1\u95EE\u9898\u8BF7\u5728", /*#__PURE__*/React.createElement("a", {
      className: "link-text",
      href: "https://bbs.fanruan.com/wenda",
      target: "_blank",
      rel: "noreferrer"
    }, "\u95EE\u7B54\u677F\u5757\u63D0\u95EE"), "\u6216", /*#__PURE__*/React.createElement("a", {
      className: "link-text",
      href: "https://service.fanruan.com/",
      target: "_blank",
      rel: "noreferrer"
    }, "\u524D\u5F80\u670D\u52A1\u5E73\u53F0"), "\u83B7\u53D6\u6280\u672F\u652F\u6301")));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    title: renderTitle(),
    wrapClassName: cx('dr-feedback-modal', ticketModalWrapperClassName),
    bodyStyle: {
      padding: 0
    },
    open: visible,
    onCancel: onCancel,
    centered: true,
    width: 800,
    footer: null,
    destroyOnClose: true
  }, /*#__PURE__*/React.createElement("iframe", {
    src: url,
    width: "100%",
    height: "500",
    style: {
      border: 'none'
    }
  }));
};
export default FeedbackTicketModal;